import React, { useEffect, useState } from 'react'
import HomeHeader from '../components/HomeHeader'
import HomeBody from '../components/HomeBody'
import HomeFooter from '../components/HomeFooter'

const Home = () => {

  const [loader, setLoader] = useState(true)
  
  useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 2000);
  });
  
  return (
    <>
    {
      loader ? <div className='waterfall'><div></div><div></div><div></div><div></div><div></div></div>
      : 
      <div className='fade-in'>
        <HomeHeader />
        <HomeBody />
        <HomeFooter />
      </div>
    }
        
    </>
  )
}

export default Home